<template>
  <div class="logo-container">LYEdge</div>
</template>

<script>
export default {
  name: 'LogoTag'
}
</script>

<style scoped>
.logo-container {
  height: var(--nav-height);
  background-color: rgb(0, 37, 60);
  /* 居中布局 */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  /* 禁止文字选中复制 */
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  /* 文字基础 */
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 1.2px;
  /* 主色调 #7058e0 渐变流光 */
  background: linear-gradient(90deg, #7058e0, #957dff, #c1afff, #7058e0);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  /* 主色调发光 */
  text-shadow: 0 0 8px rgba(112, 88, 224, 0.4);
  /* 流动流光动画 */
  animation: techShine 4s linear infinite;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
}

/* hover 强化光效 */
.logo-container:hover {
  background-color: rgba(112, 88, 224, 0.12);
  text-shadow: 0 0 14px rgba(112, 88, 224, 0.7);
  filter: brightness(1.2);
}

/* 文字流光扫动动画 */
@keyframes techShine {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 300% 50%;
  }
}

@media (max-width: 768px) {
  .logo-container {
    padding: 0 10px;
    font-size: 14px;
    letter-spacing: 0.8px;
  }
}
</style>
